import str from "@/utils/str";

const groupUrl = (group, data) => {
  Object.keys(data).forEach((key) => {
    if (typeof data[key] === "object") {
      data[key] = groupUrl(group, data[key]);
    } else {
      data[key] = group + "/" + data[key];
    }
  });
  return data;
};

export const currentUrl = (uri) => {
  return str.rtrim(baseUrl(), "/") + "/" + str.ltrim(uri, "/");
};

export const baseUrl = (root = "api/public") => {
  let apiVersion = process.env.VUE_APP_API_VERSION;
  let appVersion = process.env.VUE_APP_VERSION;
  let host = str.trim(process.env.BASE_URL, "/");
  return (
    window.location.origin +
    host.replace(appVersion, apiVersion) +
    "/" +
    str.ltrim(root, "/")
  );
};

// 以下api路徑相對於index.html
// 透過this.http.post 則相對於./api/public
export default {
  // 應用程式API
  // in App.vue
  app: {
    info: "app_info.php",
    service: "service_info.php",
    lang: "lang_info.php",
    login: "login.php",
    logout: "logout.php",
    remember: "remember.php",
  },
  dashboard: groupUrl("dashboard", {
    columns: "dashboard_columns.php",
    search: "dashboard.php",
    detailColumns: "dashboard_detail_columns.php",
    detail: "dashboard_detail.php",
  }),
  // 微商通路相關API
  tgBusiness: groupUrl("tg_business", {
    agent: groupUrl("agent", {
      privilege: {
        search: "agent_privilege.php",
        columns: "agent_privilege_columns.php",
        action: "agent_privilege_action.php",
      },
    }),
    member: groupUrl("member", {
      privilege: {
        search: "member_privilege.php",
        columns: "member_privilege_columns.php",
        action: "member_privilege_action.php",
        find: "member_privilege_find.php",
        unlock: "member_privilege_unlock.php",
      },
      review: {
        search: "member_review.php",
        action: "member_review_action.php",
        columns: "member_review_columns.php",
      },
      reward: {
        search: "member_reward.php",
        columns: "member_reward_columns.php",
        games: "member_reward_games.php",
        detail: "member_reward_detail.php",
      },
      board: groupUrl("board", {
        search: "member_board.php",
        columns: "member_board_columns.php",
        profile: "member_board_profile.php",
        directpush: "member_board_directpush.php",
      }),
    }),
    announcement: groupUrl("announcement", {
      search: "announcement_review.php",
      action: "announcement_action.php",
      columns: "announcement_columns.php",
    }),
    reward: groupUrl("reward", {
      paper: "reward_paper.php",
      paperOld: "reward_paper.php?old=1",
      record: groupUrl("record", {
        columns: "reward_record_columns.php",
        search: "reward_record.php",
        users: "reward_record_users.php",
        detail: "reward_record_detail.php",
      }),
    }),
    myTeam: groupUrl("myTeam", {
      search: "my_team_below_member.php",
      info: "my_team_member_info.php",
      chain: "my_team_member_chain.php",
      columns: "my_team_columns.php",
    }),
    level_distributed: groupUrl("level_distributed", {
      agent: "level_distributed_agent.php",
      columns: "level_distributed_columns.php",
      search: "level_distributed.php",
      member: "level_distributed_member.php",
    }),
    accounting: groupUrl("accounting", {
      search: "accounting.php",
      columns: "accounting_columns.php",
    }),
    ranking: groupUrl("ranking", {
      search: "bet_ranking.php",
      columns: "bet_ranking_columns.php",
    }),
  }),
  activity: groupUrl("activity", {
    board: {
      columns: "activity_board_columns.php",
      search: "activity_board.php",
    },
    agent: {
      columns: "activity_agent_columns.php",
      search: "activity_agent.php",
    },
    detail: {
      columns: "activity_detail_columns.php",
      search: "activity_detail.php",
    },
    member_search: {
      columns: "activity_search_columns.php",
      search: "activity_search.php",
    },
  }),
  game: groupUrl("game", {
    invest: groupUrl("invest", {
      search: "game_invest.php",
      columns: "game_invest_columns.php",
    }),
    result: groupUrl("result", {
      search: "game_result.php",
      columns: "game_result_columns.php",
    }),
    bet: groupUrl("bet", {
      search: "game_bet.php",
      columns: "game_bet_columns.php",
    }),
    language: groupUrl("language", {
      search: "game_language_list.php",
      detail: "game_language_detail.php",
      competition: "game_language_competition.php",
      update_competition: "game_language_competition_update.php",
      team: "game_language_team.php",
      update_team: "game_language_team_update.php",
      columns: "game_language_columns.php",
    }),
  }),
  accounts: groupUrl("accounts", {
    paper: {
      search: "accounts_paper.php",
      columns: "accounts_paper_columns.php",
      bet: {
        search: "accounts_paper_bet.php",
        columns: "accounts_paper_bet_columns.php",
      },
    },
    history: {
      search: "accounts_history.php",
      columns: "accounts_history_columns.php",
      export: "accounts_history_export.php",
      selection: "accounts_history_selection.php", //篩選下拉選單
    },
    reward: {
      search: "accounts_reward.php",
      columns: "accounts_reward_columns.php",
    },
    reward_info: {
      search: "accounts_reward_info.php",
      columns: "accounts_reward_info_columns.php",
    },
    contribution: {
      search: "accounts_contribution.php",
      columns: "accounts_contribution_columns.php",
    },
    bet: {
      search: "accounts_bet.php",
      columns: "accounts_bet_columns.php",
    },
    income: {
      search: "accounts_income.php",
      detail: {
        search: "accounts_income_detail.php",
        columns: "accounts_income_detail_columns.php",
      },
    },
    transfer: {
      search: "accounts_transfer.php",
      columns: "accounts_transfer_columns.php",
    },
    finance: {
      search: "accounts_finance.php",
      columns: "accounts_finance_columns.php",
    },
    return_bonus: {
      search: "accounts_return_bonus.php",
      columns: "accounts_return_bonus_columns.php",
      export: "accounts_return_bonus_export.php",
    },
    profit: {
      search: "accounts_profit.php",
      columns: "accounts_profit_columns.php",
      detail: "accounts_profit_detail.php",
    },
    public: {
      bet_default_options: "accounts_bet_default_options.php",
      profit_default_options: "accounts_profit_default_options.php",
      merchant_options: "accounts_merchant_list.php",
    },
    high_profit_members: {
      search: "accounts_high_profit_members_search.php",
      columns: "accounts_high_profit_members_columns.php",
    },
  }),
  member: groupUrl("member", {
    board: {
      columns: "member_board_columns.php",
      search: "member_board.php",
      action: "member_board_action.php",
      update_handicap: "member_board_update_handicap.php",
      update_limit_bet: "member_board_update_limit_bet.php",
      update_member_batch: "member_board_update_member_batch.php",
    },
    profile: {
      columns: "member_profile_columns.php",
      search: "member_profile.php",
    },
    sub: {
      columns: "member_sub_columns.php",
      search: "member_sub.php",
      action: "member_sub_action.php",
    },
    admin: {
      columns: "member_sub_admin_columns.php",
      search: "member_sub_admin.php",
      action: "member_sub_admin_action.php",
      permissions: "member_sub_admin_permissions.php",
    },
    action: "member_action.php",
    info: "member_info.php",
    add: {
      search: "member_add.php",
      columns: "member_add_columns.php",
    },
    trial: {
      search: "member_trial.php",
      columns: "member_trial_columns.php",
      apply_info: "member_trial_apply_info.php",
      apply: "member_trial_apply.php",
    },
    distributed: {
      columns: "member_distributed_columns.php",
      agent: "member_distributed_agent.php",
      level: "member_distributed_level.php",
      member: "member_distributed_member.php",
    },
    updateMaterial: "material_update.php",
  }),
  third_party: groupUrl("third_party", {
    public_sport: groupUrl("public", {
      detail: {
        columns: "detail_columns.php",
        search: "detail.php",
      },
      result: {
        columns: "result_columns.php",
        search: "result.php",
      },
    }),
  }),
  notice: {
    search: "notice.php",
    columns: "notice_columns.php",
  },
  online: {
    search: "online.php",
    columns: "online_columns.php",
  },
  // ip_white: {
  //   search: "ip_white/ip_white.php",
  //   columns: "ip_white/ip_white_columns.php",
  //   action: "ip_white_action.php",
  // },
  ip_white: groupUrl("ip_white", {
    search: "ip_white.php",
    columns: "ip_white_columns.php",
    action: "ip_white_action.php",
  }),
  // ip_white: groupUrl("ip_white",{
  //   search: "ip_white.php",
  //   columns: "ip_white_columns.php",
  //   action: "ip_white_action.php",
  // }),
  rule: "rule.php",
  assistence: groupUrl("assistence", {
    search: "assistence.php",
    columns: "assistence_columns.php",
    action: "assistence_action.php",
  }),
  statistic: groupUrl("statistic", {
    export: "export.php",
  }),
  dropdown: "dropdown.php",
  sms: "sms.php",
  login: "login.php",
  forgetPwd: "forgetPwd.php",
  changePwd: "changePwd.php",
  verification_image: "verification_image.php",
  validateCellphone: "validate_cellphone.php",
  getCustomerServiceIframeUrl: "getCustomerServiceIframeUrl.php",
  lang: "lang.php",
  getThirdPartys: "third_partys.php",
};
